import { Box, Flex, Text } from '@chakra-ui/react';
import { ProfileUserAvatar } from '@meritcircle/ui/components';

export type ReviewCardHeaderProps = {
  userName: string;
  userLvl?: string;
  profilePictureUrl?: string;
};

export const ReviewCardHeader = ({
  userName,
  userLvl,
  profilePictureUrl,
}: ReviewCardHeaderProps) => (
  <Flex gap="space.16" justifyContent="flex-start">
    <ProfileUserAvatar
      username={userName}
      size="size.48"
      hideUsername={true}
      avatarSrc={profilePictureUrl}
    />
    <Box>
      <Text size="md">{userName}</Text>
      {/* No more user level logic on beam */}
      {/* {userLvl && <Text size="sm">{userLvl}</Text>} */}
    </Box>
  </Flex>
);
